import { render, staticRenderFns } from "./IconSvgDelete.vue?vue&type=template&id=29ccbaa0&scoped=true&"
import script from "./IconSvgDelete.vue?vue&type=script&lang=js&"
export * from "./IconSvgDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ccbaa0",
  null
  
)

export default component.exports